import React, { useEffect, useRef } from "react";

export default function Lightbox() {
  const overlayRef = useRef(null);
  const imgRef = useRef(null);
  const captionRef = useRef(null);
  const closeRef = useRef(null);

  useEffect(() => {
    const overlay = overlayRef.current;

    function open(src, alt) {
      imgRef.current.src = src;
      imgRef.current.alt = alt || "";
      captionRef.current.textContent = alt || "";
      overlay.classList.add("open");
    }

    function close() {
      overlay.classList.remove("open");
      imgRef.current.src = "";
    }
    closeRef.current = close;

    function onDocClick(e) {
      const trigger = e.target.closest && e.target.closest("img.lb-trigger");
      if (trigger) {
        // Thumbnails now render a small srcset candidate, so the overlay has to
        // ask for the full-size file explicitly rather than reuse what loaded.
        open(trigger.dataset.full || trigger.currentSrc || trigger.src, trigger.alt);
      }
    }

    function onOverlayClick(e) {
      if (e.target === overlay) close();
    }

    function onKeyDown(e) {
      if (e.key === "Escape") close();
    }

    document.addEventListener("click", onDocClick);
    overlay.addEventListener("click", onOverlayClick);
    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.removeEventListener("click", onDocClick);
      overlay.removeEventListener("click", onOverlayClick);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);

  return (
    <div className="lightbox-overlay" id="lightbox-overlay" ref={overlayRef}>
      <button
        className="lightbox-close"
        type="button"
        aria-label="Fechar"
        onClick={() => closeRef.current && closeRef.current()}
      >
        &times;
      </button>
      <img ref={imgRef} src="" alt="" />
      <div className="lightbox-caption" ref={captionRef} />
    </div>
  );
}
